"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:jsx-no-lambda */
var React = require("react");
var Pill = /** @class */ (function (_super) {
    __extends(Pill, _super);
    function Pill(props) {
        return _super.call(this, props) || this;
    }
    Pill.prototype.render = function () {
        var _this = this;
        var pillText = this.props.label;
        if (this.props.value) {
            pillText = this.props.label + ': ' + this.props.value;
        }
        return (React.createElement("span", { className: "pill" },
            React.createElement("span", { onClick: function (e) { return _this.props.onClick(_this.props.id); } }, pillText),
            React.createElement("span", { className: "pill-close-icon", onClick: function (e) { return _this.props.onClose(_this.props.id); } }, "\u00D7")));
    };
    return Pill;
}(React.Component));
exports.Pill = Pill;
//# sourceMappingURL=Pill.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Pill/Pill.js
// module id = 590
// module chunks = 1